import React from 'react';
import TableBody from '@mui/material/TableBody';
import PropTypes from 'prop-types';

import { useMediaTableContext } from '../../../hooks';
import VpMediaTableBodyRow from './VpMediaTableBodyRow';
import VpMediaSubmissionDetailsDialog from '../../dialogs/VpMediaSubmissionDetailsDialog/VpMediaSubmissionDetailsDialog';

export const VpMediaTableBody = ({ data }) => {
  const { setSelectedSubmissionId, selectedSubmissionId } = useMediaTableContext();

  return (
    <>
      <TableBody>
        {data?.data?.map((submission) => (
          <VpMediaTableBodyRow key={submission?.campaignSubmissionId} submission={submission} />
        ))}
      </TableBody>
      <VpMediaSubmissionDetailsDialog
        open={!!selectedSubmissionId}
        onClose={setSelectedSubmissionId}
      />
    </>
  );
};

VpMediaTableBody.propTypes = {
  data: PropTypes.object
};

export default VpMediaTableBody;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpMediaTableBody.jsx